import type { FirestoreError } from 'firebase/firestore';

/**
 * Shared `onSnapshot` error handler for the Firestore sync adapters.
 *
 * Firestore listeners swallow errors silently unless an error callback is
 * provided — most importantly `permission-denied`, which fires when the JS Auth
 * SDK isn't (yet) authenticated as `uid`. That silent failure mode is exactly
 * what hid the iOS auth-sync bug (see the `capacitor-js-auth-getauth-hang`
 * note): the listener simply never delivered data and looked indistinguishable
 * from "no data". Surfacing the error makes it observable.
 */
export function logSyncError(label: string, uid: string) {
  return (err: FirestoreError): void => {
    console.error(`[${label}] onSnapshot error`, uid, err.code, err.message);
  };
}
